<template>
  <div v-if="show_body">
    <!-- 测评答题 -->
    <!-- 他评必传的参数 data  pattern  taTextObject  intro -->
    <answer-questions v-if="questBool" :cid_type="'ceping76'" :array="data.list" :interruptShow="interruptShow" :data_="data" @interruptHandle="interruptHandle"  :pattern='pattern' :taTextObject="taTextObject"  :intro="data.intro?data.intro.split('\r'):[]" @saveHeReview="saveHeReview" @saveReportHandle="saveReportHandle"></answer-questions>
    <!-- 自己 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="kc_show">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <!-- <img src="../../../assets/cep_ewm.png" /> -->
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
    <!-- 未购买 -->
    <van-popup class="pub_alert" v-model="is_buy" :close-on-click-overlay="false">
      <div class="confirm_box">
        <h2>此测评属于最佳工作模式课程，快去购买课程测评吧</h2>
        <div class="btn_group">
          <router-link class="confirm" :to="{
            path:'/course_details',
            query:{
              bid:2
            }
          }">购买最佳工作模式课程</router-link>
        </div>
      </div>
    </van-popup>
    <!-- 判断链接是否失效 -->
    <van-popup class="pub_alert" v-model="failureShow" :close-on-click-overlay="false">
        <div class="confirm_box">
            <h2 class="on">{{failureMsg}}</h2>
        </div>
    </van-popup>
    <!-- 关卡介绍 -->
    <public-level :level_list_id="level_list_id"  :cpBool="true"></public-level>
    <!-- 填写个人资料 -->
    <answer-collect :cid="data.cid" :query="$route.query" :extraObj="extraObj" v-if="userInfoBool" @saveuserinfo="saveUserInfo"></answer-collect>
    <!-- 祝福寄语 -->
    <div v-if="blessBool" class="blessing-message">
        <h3>毕业将至，你最想对  <span style="color:#3AA8D8;">{{data.ta_nickname}}</span>  说什么？</h3>
        <van-radio-group v-model="blessMsg">
          <van-radio name="凡是过去，皆为序曲。">凡是过去，皆为序曲。</van-radio>
          <van-radio name="这是一个流行离开的时代，可我们都不擅长告别。">这是一个流行离开的时代，可我们都不擅长告别。</van-radio>
          <van-radio name="别搞那么忧伤，不就是毕业嘛~ 冲啊！！">别搞那么忧伤，不就是毕业嘛~ 冲啊！！</van-radio>
          <van-radio name="出门便是江湖，剑在手无需多言。">出门便是江湖，剑在手无需多言。</van-radio>
          <van-radio name="我不信，我们的友谊就止步于此。">我不信，我们的友谊就止步于此。</van-radio>
        </van-radio-group>
        <!--  -->
        <div class='ta_bless_btn' @click="saveBless()">送出寄语</div>
    </div>
    <div v-if="blessSucc" class="blessing-succ">
      <div  >
        <div class="img">
          <img :src="data.ta_headimgurl"  />
        </div>
        <h4>感谢反馈和祝福!</h4>
        <h4>无论我们多大，只要我们在奔跑就不算结束!</h4>
        <h4 class="on">快来测测，我俩是不是同款“王者”</h4>
        <!--  -->
       <div class='ta_bless_btn' @click="toceping()">点击进入测评</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ceping76_index,
  ceping76_answer,
  ceping76_ta_answer,
  ceping76_ta_index,
  get_extra_info,
  ceping76_ta_send_word,
  ceping76_get_ta_word,
  ceping_event,
} from '@/api/measurement'
import AnswerQuestions from "@c/measurement/answer-questions";
import AnswerCollect from "@c/measurement/answer-collect";
import {
  queryString,
  getStorage,
  setStorage,
  deleteStorage
} from '@/utils/tools'
import { phoneValidation} from '@/utils/validation'
import { shareCon} from '@/utils/wxconfig'
import PublicLevel from '@c/course/public-level'
export default {
  data() {
      return {
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        },
        show_body: false,
        qrcode: "",
        //
        nickname: "",
        kc_show: false,
        // 模式
        pattern: false,
        data: {},
        // 上一页面路由
        formPath: '',
        failureShow:false,
        interruptShow:false,
        failureMsg:'',
        // 他评显示文案
        taTextObject:{},
        // 获取关卡介绍的项目id
        level_list_id:'',
        // 存储答题数据
        extra:{},
        extraObj:{},
        userInfoBool:false,
        queArr:[],
        // 他评寄语
        blessBool:false,
        blessSucc:false,
        blessMsg:'',
        taArr:[],
        questBool:true
      }
    },
    components: {
      AnswerQuestions,
      PublicLevel,
      AnswerCollect,
    },
    computed: {
      is_buy(){
        return (!this.data.is_buy && !this.data.msg && !this.pattern)
      },
      // 文字换行
      textToHtml(){
        return function(text){
          let arr = text.split('')
          arr =  arr.map((v,index)=>{
            // return index==3?v+'<br/>':
            return ((index==arr.length-1)?v+'：':v)
          });
          return arr.join('');
        }
      }
    },
    methods: {
      toceping(){
        window.location.href=location.href.split('?')[0];
      },
      // 送出寄语
      saveBless(){
        if(!this.blessMsg){
          this.$toast('请先选择寄语！');
          return
        }
        //调用加载中
        this.$emit('loadingHandle',true,"送出寄语中...");
        // 提交他评数据
        let q = this.$route.query;
        ceping76_ta_answer({
          ta_uid: q.ta_uid,
          answer: JSON.stringify(this.taArr)
        }).then((data) => {
          
        })
        ceping76_ta_send_word({
          ta_uid:this.$route.query.ta_uid,
          msg:this.blessMsg
        }).then(data=>{
           if (data.code == 10002) {
             this.$toast(data.data.msg || data.msg);
             return
           }
          //关闭加载中
          this.$emit('loadingHandle',false);
          this.blessBool = false;
          this.blessSucc = true;
        });
      },
      interruptHandle(bool){
        this.interruptShow = bool;
      },
      // 提交个人信息和答题数据
      saveUserInfo(extra){
        if(extra) {
          this.extra = extra;
        }
        
        let arr  = this.queArr;
        let obj = {
          answer: JSON.stringify(arr)
        };
        if(this.$route.query.sid){
          obj['sid'] = this.$route.query.sid;
        }
        for(let i=0;i<Object.keys(this.extraObj).length;i++){
          let item = Object.keys(this.extraObj)[i];
          if(!this.extra[item]){
            this.$toast(`${this.extraObj[item]}不能为空！`);
            return
          }else if(!phoneValidation(this.extra.phone)){
            this.$toast('手机号格式不正确！');
            return
          }else{
            obj[item] = this.extra[item];
          }
        }
        
        this.$toast.loading({
          mask: true,
          message: "提交中..."
        });
        // 
        ceping76_answer(obj).then((data) => {
          if (this.subscribe) {
            // 提交删除缓存
            deleteStorage(this.$route.path);
            let q = this.$route.query;
            if (this.formPath === '/ceping76_report') {
              this.$router.back();
            } else {
              q['uid'] = data.uid;
              this.$router.push({
                path: '/ceping76_report',
                query: q
              })
            }
          } else {
            this.kc_show = true;
          }
        });
      },
      /*
       *@param: arr
       *@return: 
       *@Description: 获得他评提交的答题数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-05 11:40:57
      */
      saveHeReview(arr){
        this.questBool = false;
        //调用加载中
        this.$emit('loadingHandle',true,"提交他评数据中...");
        setTimeout(()=>{
          this.taArr = arr;
          this.blessBool = true;
          //关闭加载中
          this.$emit('loadingHandle',false);
        },2000);
        
      },
      /*
       *@param: arr
       *@return: 
       *@Description: 获得提交的答题数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-01 15:28:13
      */
      saveReportHandle(arr){
        let bool = true;
        get_extra_info().then(data=>{
          for(let i=0;i<Object.keys(this.extraObj).length;i++){
            let item = Object.keys(this.extraObj)[i];
            if(data.extra[item]){
              this.extra[item] = data.extra[item];
            }else{
              bool = false;

            }
          }
          this.queArr = arr;
          if(bool){
            this.saveUserInfo();
          }else{
            this.userInfoBool = true;
          }
        });
      },
      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        if (!this.pattern) {
          // 自己
          let q = this.$route.query;
          // 获取关卡信息
          this.level_list_id = q.level_list_id?q.level_list_id:'';
          let obj = {
            share_uid: q.share_uid || "",
            channel: q.channel || ""
          };
          if(this.$route.query.code){
            obj['code'] = this.$route.query.code;
          }
          ceping76_index(obj).then((data) => {
              this.data = data;
              if (data.code != 10002) {
                this.type_obj.evaluation_id = data.cid;          
                this.type_obj.evaluation_name = data.headtitle;          
                this.type_obj.evaluation_user_id = data.uid;          
                this.type_obj.nickname = data.nickname;          
                this.type_obj.path = this.$route.path;       
                shareCon("ceping76", this, this.type_obj);
                //判断是否是已购买课程并且链接已使用或者失效
                if(data.msg){
                  this.failureMsg = data.msg;
                  this.failureShow = true;
                }else{
                  //判断是否是已购买课程并且有本地缓存
                  if (data.is_buy && window.localStorage.getItem(this.$route.path)) {
                    this.interruptShow = true;
                  }
                  // 设置数据
                  this.initCptData(data);
                }
                // 显示
                this.show_body = true;

              } else {
                if (this.formPath === '/ceping76_report') {
                  this.$router.back();
                } else {
                  this.$router.push({
                    path:'/ceping76_report',
                    query:this.$route.query
                  });
                }

              };
              //关闭加载中
              this.$emit('loadingHandle',false);

              ceping_event({ lead_sid: this.$route.query.lead_sid,
                cid: data.cid,
                event: 'ViewIndex',
              }).then(res=>{
                // 页面访问统计
              });
              
              // 神策统计--打开页面时触发
              // sensors.track('evaluationPage', {
              //   evaluation_id: String(data.cid),
              //   evaluation_name: data.headtitle,
              //   evaluation_url: window.location.href,
              //   evaluation_page_title: data.headtitle,
              //   share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
              //   channel_name: this.$route.query.channel ? this.$route.query.channel : ""
              // })
            })
        } else {
          let obj = {
            ta_uid: this.$route.query.ta_uid
          };
          if(this.$route.query.code){
            obj['code'] = this.$route.query.code;
          }
          // 别人
          ceping76_ta_index(obj).then((data) => {
              this.data = data;
              //关闭加载中
              this.$emit('loadingHandle',false);
              if (data.code != 10002) {
                this.type_obj.evaluation_id = data.cid;          
                this.type_obj.evaluation_name = data.headtitle;          
                this.type_obj.evaluation_user_id = data.uid;          
                this.type_obj.nickname = data.nickname;          
                this.type_obj.path = this.$route.path;          
                shareCon("ceping76", this, this.type_obj);
                let off = data.uid == this.$route.query.ta_uid;
                if (off) {
                  // 自己评自己
                  this.$router.push('/ceping76_report');
                  return
                }
                this.show_body = true;
                // 设置数据
                this.initCptData(data);
                // 显示
              }else{
                if(!data.data.ta_nickname){
                  if (this.formPath === '/ceping76_report') {
                    this.$router.back();
                  } else {
                    this.$router.push({
                      path:'/ceping76_report',
                      query:this.$route.query
                    });
                  }
                }else{
                  this.blessSucc = true;
                  this.show_body = true;
                }
                
              }
              let ta_nickname = data.code == 10002?data.data.ta_nickname:data.ta_nickname;
              this.taTextObject = {
                path:'ceping76',
                toPath:'/ceping76',
                type:'ad',
                arr:[
                `感谢你完成了对<span style="font-weight: bold;color:#EB5032;">${ta_nickname}</span>的能力评价。`
                ]
              };
            })
        }

      },
      initCptData(data) {
        this.subscribe = data.subscribe;
        if (!data.need_subscribe) {
          this.subscribe = true;
        }
        this.qrcode = data.qrcode;
        //
        this.nickname = data.nickname;
        document.title = data.headtitle?data.headtitle:'可迁移能力报告';
        this.extraObj = data.extra || {};
      },
      
      setPattern() {
        let isMy = this.$route.query.ta_uid;
        if (isMy) {
          this.pattern = true;
        } else {
          this.pattern = false;
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created() {
      this.setPattern();
      this.pullData();
    }
}
</script>
<style lang="scss">
.blessing-succ{
  position: fixed;
  height:100%;
  width:100%;
  max-width:750px;
  transform: translateX(-50%);
  left: 50%;
  top: 0;
  overflow-y: auto;
  background:url('../../../assets/ceping76/blessing-message.png') center no-repeat;
  background-size: 100% 100%;
  padding:100px 62px;
  text-align:center;
  .img{
    background:url('../../../assets/ceping76/bless-head-bg.png') center no-repeat;
    background-size: 100% 100%;
    width:150px;
    height:140px;
    margin:0 auto 72px;
    text-align:left;
    img{
      width:127px;
      height:127px;
      margin-top:6px;
      margin-left:8px;
      border-radius:50%;
    }
  }
  h4{
    font-size:34px;
    color:#343434;
    line-height:39px;
    margin:0 auto 40px;
    text-align:center;
    width:550px;
  }
  h4.on{
    margin-bottom:230px;
  }
  .ta_bless_btn{
    width:344px;
    height:90px;
    line-height:80px;
    text-align:center;
    font-size:34px;
    color:#000000;
    background:url('../../../assets/ceping76/ta_bless_btn.png') center no-repeat;
    background-size: 100% 100%;
    margin:0 auto;
    font-weight:bold;
  }
}
.blessing-message{
  .van-radio__icon{
    height:30px;
    line-height:30px;
    margin-left:10px;
  }
  .van-radio__icon--checked .van-icon.van-icon-success{
    background-color:#3AA8D8;
    
  }
  .van-radio__icon .van-icon.van-icon-success{
    width:30px;
    height:30px;
    border:2px solid #3AA8D8;
    &:before{
      content:'';
    }
  }
}
</style>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.blessing-message{
  position: fixed;
  height:100%;
  width:100%;
  max-width:750px;
  transform: translateX(-50%);
  left: 50%;
  top: 0;
  overflow-y: auto;
  background:url('../../../assets/ceping76/blessing-message.png') center no-repeat;
  background-size: 100% 100%;
  padding:100px 52px 100px 62px;
  h3{
    font-size:34px;
    color:#343434;
    width:630px;
    padding-bottom:32px;
    border-bottom:4px solid #3AA8D8;
    margin-bottom:86px;
  }
  .van-radio{
    margin-bottom:60px;
    font-size:26px;
    &:last-child{
      margin-bottom:155px;
    }
  }
  .ta_bless_btn{
    width:344px;
    height:90px;
    line-height:80px;
    text-align:center;
    font-size:34px;
    color:#000000;
    background:url('../../../assets/ceping76/ta_bless_btn.png') center no-repeat;
    background-size: 100% 100%;
    margin:0 auto;
    font-weight:bold;
  }
}
.progress {
  position: fixed;
  height: 8px;
  left: 0;
  top: 0;
  z-index: 3;
  background: red;
  transition: all .3s;
}

.pg-num {
  position: fixed;
  padding: 10px;
  top: 10px;
  right: 10px;
  z-index: 4;
  background: red;
  transition: all .3s;
  color: #fff;
  border-radius: 30px;
}
.m-error{
  bottom: 60px;
  position: fixed;
  width: 80px;
  line-height: 80px;
  height: 80px;
  text-align: center;
  right: 40px;
  z-index: 4;
  background: #fff;
  transition: all .3s;
  color: #F57F17;
  border: 2px solid #F57F17;
  border-radius: 50%;
  box-sizing: border-box;
}
.error-pop{
  background: transparent;
}
.error{
  background-color: #ffffff;
  width: 690px;
  padding: 30px;
  border-radius: 15px;
  h3{
    font-size: 34px;
    color: #333;
  }
  textarea{
    margin: 40px auto 90px;
    resize:none;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 8px;
    line-height: 39px;
    width: 100%;
    background-color: #f5f5f5;
  }
  .error-footer{
    border-top:1px solid #d3d3d3;
    display: flex;
    position: absolute;
    bottom:0;
    width: 100%;
    left: 0;
    line-height: 90px;
    a{
      flex: 1;
      text-align: center;
      font-size: 34px;
      color: #333;
      &:nth-child(1){
        color: #EB5032;
      }
      &:nth-child(2){
        color: #666666;
        border-left: 1px solid #d3d3d3;
      }
    }
  }
}

.mt32 {
  margin-top: 32px;
}

.pt32 {
  padding-top: 32px;
}

.pb-public {
  padding: changeRem(0.425)+px;
}


.pop {
  img {
    max-width: 8rem;
  }
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.confirm_box {
  h2 {
    padding: 40px 30px;
  }
  h2.on {
    padding: 60px 30px;
  }
  p {
    margin-bottom: 50px;
    font-size: 26px;
    color: #666;
  }
  .btn_group {
    .confirm {
      color: #999999;
    }
    .cancel {
      color: #EB5032;
    }
  }
}

// 弹出开始测评说明
.answer-sheet {
  transition: all 2s;
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.answer-sheet.on {
  left: -1500px;
}
.save-userinfo{
  position: fixed;
  width: 100%;
  max-width: 750px;
  left: -100%;
  transform: translateX(-50%);
  top: 0;
  height: 100%;
  background-color: #ffffff;
  padding: 150px 60px 100px;
  overflow: auto;
  .u-title{
    font-size: 36px;
    color: #333;
    text-align: center;
    margin-bottom: 80px;
    font-weight: bold;
  }
  .u-input{
    display: flex;
    align-items: center;
    font-size: 30px;
    margin-bottom: 50px;
    label{
      display: block;
      width: 150px;
      text-align: right;
    }
    input{
      line-height: 70px;
      flex: 1;
      border:2px solid #F57F17;
      border-radius: 15px;
      padding-left: 10px;
      font-size: 26px;
      background-color: #ffffff;
    }
    .interest-label{
      width: 600px;
    }
    .interest-label.on{
      width: 150px;
      text-align: right;
    }
  }
  .u-input.on{
    flex-direction: column;
    label{
      display: block;
      margin-right: auto;
      text-align: left;
    }
    .ra{
      width:100%;
      line-height:80px;
      padding-left:150px;
    }
  }
  .u-btn{
    display: block;
    margin: 0 auto;
    width: 100%;
    border-radius: 15px;
    border: none;
    background-color: #F57F17;
    font-size: 32px;
    text-align: center;
    color: #ffffff;
    line-height: 80px;
  }
}
.save-userinfo.on{
  left: 50%;
}
</style>
